import { FC } from 'react';
import { isFilled } from '@prismicio/client';
import type { RichTextField } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';

interface HeadlineProps {
  field?: RichTextField;
}

/**
 * Shared hero H1: Inter 500 / 40px mobile / 55px desktop / 120% / white.
 * The `!` important markers keep the global `h1` reset from overriding size
 * and weight. Renders nothing when the field is empty.
 */
const Headline: FC<HeadlineProps> = ({ field }) => {
  if (!isFilled.richText(field)) {
    return null;
  }
  return (
    <PrismicRichText
      field={field}
      components={{
        heading1: ({ children }) => (
          <h1 className="m-0 font-inter !text-[40px] !font-medium !leading-[1.2] tracking-normal text-white md:!text-[55px]">
            {children}
          </h1>
        ),
      }}
    />
  );
};

export default Headline;
